const {formSubmitEvents} = require("app_superdry/helpers/gtmHelpers");

/**
 * Shows the server's error messages above the submit button, or the form's generic message when there are none
 * @param {jQuery} form - the .dynamic-form
 * @param {Object} [response] - the route's JSON: `errors` (one message per field) or a single `msg`
 */
function showResponseError(form, response) {
    const responseErrorMsgEl = form.find(".response-error-msg");
    responseErrorMsgEl.empty().addClass("d-none");

    const errors = response && (Array.isArray(response.errors) ? response.errors : [response.msg]).filter(Boolean);

    if (errors && errors.length > 0) {
        const errorList = $("<ul></ul>");
        errors.forEach(function (error) {
            errorList.append($("<li></li>").text(error));
        });
        responseErrorMsgEl.append(errorList).removeClass("d-none");
    } else {
        responseErrorMsgEl.text(form.attr("data-error-message")).removeClass("d-none");
    }
}

$(document).ready(function () {
    $(".dynamic-form").on("submit", function (e) {
        e.preventDefault();

        const formID = $(this).attr("id");
        const form = $(this);
        const formWrapper = $(`#${formID}_formWrapper`);
        const successMessageWrapper = $(`#${formID}_subscribedMessage`);
        const submitButton = form.find("button[type=submit]");
        const url = form.attr("action");
        const formName = form.find("input[name=formName]").val() ?? "";
        const email = form.find("input[name=email]").val() ?? "";
        // Build single dob string. Use the month's value, not its text: the placeholder's text ("Month") is truthy.
        // A partly filled date is still sent so the server can say which parts are missing.
        const day = form.find("input[name=day]").val() ?? "";
        const month = form.find("select[name=month]").val() ?? "";
        const year = form.find("input[name=year]").val() ?? "";
        const dob = day || month || year ? `${day}-${month}-${year}` : "";
        const formData = {
            firstName: form.find("input[name=firstName]").val() ?? "",
            lastName: form.find("input[name=lastName]").val() ?? "",
            email: email,
            optIn: form.find("input[name=optIn]:checked").val() === "true" ? "Y" : "N",
            preference: form.find("input[name=preference]:checked").val() ?? "",
            dob: dob,
            phone: form.find("input[name=phone]").val() ?? "",
            csrf_token: form.find("input[name=csrfToken]").val() ?? "",
            formType: form.find("input[name=formType]").val() ?? "",
            formName: formName
        };
        form.spinner().start();
        submitButton.attr("disabled", true);
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: formData,
            success: function (data) {
                if (data.success) {
                    formSubmitEvents(formName, email);
                    formWrapper.addClass("d-none");
                    successMessageWrapper.removeClass("d-none");
                } else {
                    // The route answers validation and subscription failures with 200 and { error: true, msg }
                    showResponseError(form, data);
                }
            },
            error: function (jqXHR) {
                showResponseError(form, jqXHR.responseJSON);
            },
            complete: function () {
                submitButton.attr("disabled", false);
                form.spinner().stop();
            }
        });
    });
});

module.exports = {
    showResponseError: showResponseError
};
